/**
 * 由于window本身没有监听pushState/replaceState的方法，所以二次封装给window绑定监听pushState/replaceState的方法
 * 为window绑定pushState监听的方法，只要触发了pushState就收到通知
 * 应用场景
 *   页面的无感知跳转，通过pushState/replateState的方法携带参数进行当前页面的跳转，只刷新数据不刷新页面
 *   通过监听state的改变进行一些处理，调用listenPushState/listenReplaceState，接收state的值
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * pushState和replaceState的区别
 *  pushState是添加历史记录的，而replaceState是不添加的
 */
var wrapState = function (action) {
    if (typeof window !== 'undefined') {
        // 获取原始定义
        var raw_1 = window.history[action];
        return function () {
            // 经过包装的pushState或replaceState
            // @ts-ignore
            var wrapper = raw_1.apply(this, arguments);
            // 定义名为action的事件
            var e = new Event(action);
            // 将调用pushState或replaceState的参数作为stateInfo属性放到时间参数e上面
            // @ts-ignore
            e.stateInfo = __assign({}, arguments);
            // 调用pushState或replaceState时触发该事件
            window.dispatchEvent(e);
            return wrapper;
        };
    }
};
typeof window !== 'undefined' && (window.history.pushState = wrapState('pushState'));
typeof window !== 'undefined' && (window.history.replaceState = wrapState('replaceState'));
/**
 * 进行页面的跳转携带state参数，并且不会造成页面的刷新
 * @param data state的数据
 * @param title 页面的title
 * @param url 页面的url拼接上state的值，不然页面看不到state的值，分享也不能直接分享改变后的地址(不能跨域)
 * @returns
 */
var pushState = function (data, title, url) {
    if (title === void 0) { title = ''; }
    if (typeof window === 'undefined') {
        return;
    }
    window.history.pushState(data, title, url);
};
/**
 *
 * @param data state的数据
 * @param title 页面的title
 * @param url 页面的url拼接上state的值，不然页面看不到state的值，分享也不能直接分享改变后的地址(不能跨域)
 * @returns
 */
var replaceState = function (data, title, url) {
    if (title === void 0) { title = ''; }
    if (typeof window === 'undefined') {
        return;
    }
    window.history.replaceState(data, title, url);
};
// 监听pushState的改变
var listenPushState = function (callback) {
    if (typeof window === 'undefined') {
        return;
    }
    window.addEventListener('pushState', function (state) {
        callback(state.stateInfo);
    });
};
// 监听replaceState的改变
var listenReplaceState = function (callback) {
    if (typeof window === 'undefined') {
        return;
    }
    window.addEventListener('replaceState', function (state) {
        callback(state.stateInfo);
    });
};
// 监听页面的返回
var listenPopState = function (callback) {
    if (typeof window === 'undefined') {
        return;
    }
    window.addEventListener('popstate', function (event) {
        callback(event);
    });
};
export { pushState, replaceState, listenPushState, listenReplaceState, listenPopState };
